/*
 * DAW · Section « Journal de bord » — le feuilletage.
 *
 * Principe : la page est déjà complète quand ce script démarre. Tous les numéros
 * sont écrits par Shopify dans le HTML, avec de vrais liens vers les articles ;
 * sans JavaScript ils s'affichent simplement à la suite. Ce fichier ne fait
 * qu'ajouter une couche d'apparence : la classe « is-ready » bascule la mise en
 * page en pages superposées, et on passe de l'une à l'autre.
 *
 * Conséquence volontaire : aucun contenu n'est chargé au clic, et aucune page
 * n'est masquée par « display: none ». Opacité et transformation seulement — le
 * contenu reste dans le document, exactement comme aujourd'hui.
 */
(function () {
  'use strict';

  var TURN = 360; /* doit rester sous la durée de transition du CSS */

  function setup(root) {
    if (root.dataset.dawJnReady === '1') return;

    var pages = [];
    var all = root.querySelectorAll('.daw-jn__page');
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest('.daw-jn') === root) pages.push(all[i]);
    }
    if (pages.length < 2) return;

    root.dataset.dawJnReady = '1';
    root.classList.add('is-ready');

    var prev = root.querySelector('[data-daw-jn-prev]');
    var next = root.querySelector('[data-daw-jn-next]');
    var cur = root.querySelector('[data-daw-jn-current]');
    var tot = root.querySelector('[data-daw-jn-total]');
    var index = 0;
    var busy = false;

    if (tot) tot.textContent = String(pages.length);

    function paint() {
      for (var i = 0; i < pages.length; i++) {
        var page = pages[i];
        if (i === index) {
          page.classList.add('is-on');
          page.removeAttribute('aria-hidden');
          page.inert = false;
        } else {
          page.classList.remove('is-on');
          page.setAttribute('aria-hidden', 'true');
          /* « inert » empêche le clavier d'atteindre les liens des numéros
             masqués. Là où il n'existe pas, aria-hidden suffit aux lecteurs
             d'écran ; le pire cas reste un lien atteignable au clavier. */
          page.inert = true;
        }
        page.classList.remove('is-turning');
      }
      if (cur) cur.textContent = String(index + 1);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === pages.length - 1;
    }

    function go(step) {
      var target = index + step;
      if (busy || target < 0 || target >= pages.length) return;
      busy = true;
      pages[index].classList.add('is-turning');
      window.setTimeout(function () {
        index = target;
        paint();
        busy = false;
      }, TURN);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(1);
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.target && event.target.closest('a')) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
      }
    });

    /* Le glissement du doigt : le geste qui donne tout son sens au journal sur
       téléphone et sur tablette. Seuil de 45 pixels, et on ignore le geste s'il
       est plus vertical qu'horizontal — sinon on vole le défilement de la page. */
    var x0 = null;
    var y0 = null;

    root.addEventListener(
      'touchstart',
      function (event) {
        x0 = event.touches[0].clientX;
        y0 = event.touches[0].clientY;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (event) {
        if (x0 === null) return;
        var dx = event.changedTouches[0].clientX - x0;
        var dy = event.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        x0 = null;
        y0 = null;
      },
      { passive: true }
    );

    paint();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-daw-journal]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* L'éditeur de thème recharge les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', boot);
})();
